import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'checkbox-cell',
  template: '<input *ngIf="isEditable" type="checkbox" [(ngModel)]="value" />',
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }
  get isEditable(): boolean {
    const editable = this.params.colDef.editable;
    if (typeof editable === 'function') {
      return editable(this.params as any);
    } else {
      return editable;
    }
  }

  get value(): boolean {
    return this.params.data[this.params.colDef.field];
  }
  set value(value: boolean) {
    this.params.data[this.params.colDef.field] = value;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}
